class Config {
  configURL() {
    return {
      PreLoginURL:
        'https://dev-hksso.knowcross.com/SSOServer/SSO.svc/RestService/PreLogin',
      LoginURL:
        'https://dev-hksso.knowcross.com/SSOServer/SSO.svc/RestService/Login',
      KnowcrossLogin: 'https://dev-login.knowcross.com/',
      Domain: '.knowcross.com',
    };
  }
  showICP() {
    return {
      displayICPLogo: true,
      ICPLabel: '沪ICP备2021019899号-1',
      ICPLink: 'https://beian.miit.gov.cn/',
      displayPSBLogo: true,
      PSBLabel: '宁公网安备 64050202000147号',
      PSBLink: 'http://www.beian.gov.cn/',
    };
  }

  propertiesWithAuthorization() {
    return [];
  }

  secureDomain() {
    return {
      cookie: true,
    };
  }
}
const config = new Config();
export default config;



// WEBPACK FOOTER //
// ./src/config/config.js